import React from "react";
import Sidebar from "../../../layout/Sidebar";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";

export default function AddStaff(){
    return (
        <div class="container body">
                <div class="main_container">
                 <Sidebar />
                 <Header pageTitle="Add Staff" />
                    {/* page */}
                    <div className="right_col" role="main">
  
  
  {/* /top tiles */}
  {/* body card start */}
  <div className="x_panel">
    <div className="x_title">
      <h2> Entry</h2>
      <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
        <li>
          <a className="collapse-link">
            <i className="fa fa-chevron-up" />
          </a>
        </li>
        {/* <li class="dropdown">
                   <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><i class="fa fa-wrench"></i></a>
                   <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" href="#">Settings 1</a>
                      <a class="dropdown-item" href="#">Settings 2</a>
                   </div>
                </li>
                <li><a class="close-link"><i class="fa fa-close"></i></a>
                </li> */}
      </ul>
      <div className="clearfix" />
    </div>
    <div className="x_content">
      <div className="row">
        <div className="col-sm-12">
          {/* filter start */}
          <div className="filtercont">
            <div className="row">
              <div className="col-12 col-sm-4 mb-3">
                <label>
                  Staff Name <span className="red">*</span>
                </label>
                <input type="text" className="form-control" />
              </div>
              <div className="col-12 col-sm-4 mb-3">
                <label>
                  Mobile No. <span className="red">*</span>
                </label>
                <input type="text" className="form-control" />
              </div>
              <div className="col-12 col-sm-4" />
              <div className="col-12 col-sm-4 mb-3">
                <label>Email ID</label>
                <input type="text" className="form-control" />
              </div>
              <div className="col-12 col-sm-4 mb-3">
                <label>
                  Password <span className="red">*</span>
                </label>
                <input type="Password" className="form-control" />
              </div>
              <div className="col-lg-12">
                <hr />
              </div>
              <div className="col-12 col-sm-8 mb-3">
                <label>
                  Street Address <span className="red">*</span>
                </label>
                <textarea className="form-control" defaultValue={""} />
              </div>
              <div className="col-12 col-sm-3" />
              <div className="col-12 col-sm-3 mb-3">
                <label>
                  City <span className="red">*</span>
                </label>
                <select className="form-select">
                  <option value="">Select</option>
                </select>
              </div>
              <div className="col-12 col-sm-3 mb-3">
                <label>
                  State <span className="red">*</span>
                </label>
                <select className="form-select">
                  <option value="">Select</option>
                </select>
              </div>
              <div className="col-12 col-sm-2 mb-3">
                <label>
                  Pincode <span className="red">*</span>
                </label>
                <input type="text" className="form-control" />
              </div>
              <div className="col-lg-12">
                <hr />
              </div>
              <div className="col-lg-12">
                <hr />
              </div>
              <div className="col-12 col-sm-6 mb-3">
                <label>Commission (In Percentage)</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. 2%, 10% etc"
                />
              </div>
              <div className="col-12" />
              <div className="col-12 col-sm-6 mb-3">
                <label>About The Staff</label>
                <textarea className="form-control" defaultValue={""} />
              </div>
              <div className="col-12" />
              <div className="col-12 col-sm-3">
                <input type="checkbox" id="active" />
                <label htmlFor="active" className="form-label">
                  Active/Deactive
                </label>
              </div>
              <div className="col-12 col-sm-3 text-right">
                <a href="#" className="btn sitebtn d-inline-block">
                  Submit
                </a>
              </div>
            </div>
          </div>
          {/* filter end */}
        </div>
      </div>
    </div>
  </div>
  {/* bod card end */}
  {/* body card start */}
  <div className="x_panel d-none">
    <div className="x_title">
      <h2>Cast List</h2>
      <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
        <li>
          <a className="collapse-link">
            <i className="fa fa-chevron-up" />
          </a>
        </li>
        {/* <li class="dropdown">
                   <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><i class="fa fa-wrench"></i></a>
                   <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" href="#">Settings 1</a>
                      <a class="dropdown-item" href="#">Settings 2</a>
                   </div>
                </li>
                <li><a class="close-link"><i class="fa fa-close"></i></a>
                </li> */}
      </ul>
      <div className="clearfix" />
    </div>
    <div className="x_content">
      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <table
              id="datatable-checkbox"
              className="table table-striped table-bordered bulk_action mytable"
              style={{ width: "100%" }}
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  <th style={{ width: 20 }}>S.No</th>
                  <th style={{ width: "" }}>Religion</th>
                  <th style={{ width: "" }}>Cast</th>
                  <th style={{ width: 70 }}>Status</th>
                  <th style={{ width: 70 }}>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Hindu</td>
                  <td>kshatriya</td>
                  <td>
                    <div className="checkbox-wrapper-8">
                      <input
                        className="tgl tgl-skewed"
                        id="cb3-10"
                        type="checkbox"
                        defaultChecked=""
                      />
                      <label
                        className="tgl-btn"
                        data-tg-off="Inactive"
                        data-tg-on="Active"
                        htmlFor="cb3-10"
                      />
                    </div>
                  </td>
                  <td className="p-0">
                    <ul className="actionlist">
                      <li>
                        <a href="#" className="" title="View Profile">
                          <i className="fa fa-edit" />
                        </a>
                      </li>
                      <li>
                        <a href="#" className="" title="Delete">
                          <i className="fa fa-trash" />
                        </a>
                      </li>
                      <li></li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Hindu</td>
                  <td>brahmin</td>
                  <td>
                    <div className="checkbox-wrapper-8">
                      <input
                        className="tgl tgl-skewed"
                        id="cb3-11"
                        type="checkbox"
                        defaultChecked=""
                      />
                      <label
                        className="tgl-btn"
                        data-tg-off="Inactive"
                        data-tg-on="Active"
                        htmlFor="cb3-11"
                      />
                    </div>
                  </td>
                  <td className="p-0">
                    <ul className="actionlist">
                      <li>
                        <a href="#" className="" title="View Profile">
                          <i className="fa fa-edit" />
                        </a>
                      </li>
                      <li>
                        <a href="#" className="" title="Delete">
                          <i className="fa fa-trash" />
                        </a>
                      </li>
                      <li></li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Hindu</td>
                  <td>vaishya</td>
                  <td>
                    <div className="checkbox-wrapper-8">
                      <input
                        className="tgl tgl-skewed"
                        id="cb3-12"
                        type="checkbox"
                      />
                      <label
                        className="tgl-btn"
                        data-tg-off="Inactive"
                        data-tg-on="Active"
                        htmlFor="cb3-12"
                      />
                    </div>
                  </td>
                  <td className="p-0">
                    <ul className="actionlist">
                      <li>
                        <a href="#" className="" title="View Profile">
                          <i className="fa fa-edit" />
                        </a>
                      </li>
                      <li>
                        <a href="#" className="" title="Delete">
                          <i className="fa fa-trash" />
                        </a>
                      </li>
                      <li></li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Hindu</td>
                  <td>shudra</td>
                  <td>
                    <div className="checkbox-wrapper-8">
                      <input
                        className="tgl tgl-skewed"
                        id="cb3-13"
                        type="checkbox"
                        defaultChecked=""
                      />
                      <label
                        className="tgl-btn"
                        data-tg-off="Inactive"
                        data-tg-on="Active"
                        htmlFor="cb3-13"
                      />
                    </div>
                  </td>
                  <td className="p-0">
                    <ul className="actionlist">
                      <li>
                        <a href="#" className="" title="View Profile">
                          <i className="fa fa-edit" />
                        </a>
                      </li>
                      <li>
                        <a href="#" className="" title="Delete">
                          <i className="fa fa-trash" />
                        </a>
                      </li>
                      <li></li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* bod card end */}
  
</div>

                    {/* page end */}
                  <Footer />

                  </div>
             </div>
    );
}